// Vendor imports
const React = require('react')
const { Route, Switch } = require('react-router-dom')
// Client V2 common imports
const withCommonRoot = require('client-v2/common/components/root')
// Entry imports
const ContentProfileLayout = require('client-v2/into-landing/pages/content-profile/component-smart')
const TopicProfileLayout = require('client-v2/into-landing/pages/topic-profile/component-smart')
const UserProfileLayout = require('client-v2/into-landing/pages/user-profile/component-smart')

function IntoLandingLayout() {
  return (
    <Switch>
      <Route component={ContentProfileLayout} exact={true} path={'/!:hash'}/>
      <Route component={TopicProfileLayout} exact={true} path={[
        '/mix/:slug',
        '/i/:slug',
        '/interest/:slug',
        '/mix/:slug/followers',
        '/i/:slug/followers',
        '/interest/:slug/followers',
        '/topic/:slug']
      }/>
      <Route component={UserProfileLayout} exact={true} path={['/:username', '/:username/posts']}/>
    </Switch>
  )
}

const wrappedComponent = withCommonRoot(IntoLandingLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  IntoLandingLayout
})
